import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import org_api from '../api/admin/admin_orgs'
import org_admin_api from '../api/orgadmin/orgadmin_orgs'
import customer_api from '../api/customer/customer_orgs'
import profapi from "../api/profile";
import cancel from '../assets/cancel_white.png'
import edit from '../assets/grey_pen.png'
import cloud from '../assets/upload_cloud.png'
import AdminReportOverviewGrid from '../components/AdminReportOverviewGrid'
import CommercialValuationRequestsToggle from '../components/CommercialValuationRequestsToggle'
import ReportLengthChooseAllowToggle from '../components/ReportLengthChooseAllowToggle'
import DefaultReportLengthSelect from '../components/DefaultReportLengthSelect'
import CreditBasedBillingCard from '../components/CreditBasedBillingCard'
import GenericDialog from '../components/GenericDialog'
import MainHeader from '../components/MainHeader'
import ManagementReports from '../components/ManagementReports'
import OrganisationCreditDetails from '../components/OrganisationCreditDetails'
import OrganisationPeople from '../components/OrganisationPeople'
import OrganisationReportSummary from '../components/OrganisationReportSummary'
import OrganisationTeamSummary from '../components/OrganisationTeamSummary'
import Slider from '../components/Slider'
import UsageBasedBillingCard from '../components/UsageBasedBillingCard'
import { defaultRange } from '../components/finviseMetrics'
import OrganisationConstants from '../models/OrganisationConstants'
import roles from '../models/Roles'
import ImageUtils from '../utils/ImageUtils'
import { hasDashboardAccess } from '../utils/dashboardAccess'
import FinviseDashboard from './FinviseDashboard'
import FinviseFeeRules from './FinviseFeeRules'
import FinviseProperties from './FinviseProperties'

const AdminOrganisation = (props) => {
	const params = new URLSearchParams(window.location.search)
	const org_id = params.get('id')
	const location = useLocation()
	const [organisation, setOrganisation] = useState()
	const [profile, setProfile] = useState()
	const [filter, setFilter] = useState()
	const [notifications, setNotifications] = useState()
	const [activeSection, setActiveSection] = useState(
		location.state?.section ?? props.initialSection ?? OrganisationConstants.SUMMARY_SECTION,
	)
	const [orgAddress, setOrgAddress] = useState('')
	const [editAddress, setEditAddress] = useState(false)
	// shared between FinviseDashboard and FinviseProperties so picking a
	// period on one carries over to the other
	const [finviseRange, setFinviseRange] = useState(defaultRange)
	const [finviseOrgFilter, setFinviseOrgFilter] = useState([])

	// Error Popup
	const [errorMessage, setErrorMessage] = useState('')
	const [errorTitle, setErrorTitle] = useState('')
	const okButton = [{ text: 'OK', id: '1' }]

	const [files, setFiles] = useState([])

  const getProfile = () => {
    let response = profapi.getProfile();
    response.then(
      response => {
        setProfile(response.data);
      }
    ).catch(err => {
      console.log(err);
    })
  }

	const getOrganisation = () => {
		if (!profile) return

		let response = null
		if (profile.role_id === roles.ROLE_ADMIN && org_id) {
			// Pass the id through to the api call for full admin
			response = org_api.getOrganisation(org_id)
		} else if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
			// Let the api determine the org id based on the org admin logged in
			response = org_admin_api.getOrganisation()
		} else {
			response = customer_api.getOrganisation()
    }

		response.then(response => {
			if (
				response.data.organisations &&
				response.data.organisations.length > 0
			) {
				setOrganisation(response.data.organisations[0])
				setOrgAddress(response.data.organisations[0].address)
				if (
					response.data.organisations[0].rics_terms_filename &&
					response.data.organisations[0].rics_terms_filename.name
				) {
					setFiles([response.data.organisations[0].rics_terms_filename])
				}
			}
		})
	}

	const submitOrgAddress = () => {
		if (!org_id) return
		let _body = { address: orgAddress }
		let response = org_api.putOrgAddress(org_id, _body)
		response
			.then(response => {
				setErrorTitle('Organisation Address Change')
				setErrorMessage('Address successfully uploaded')
			})
			.catch(err => {
				setErrorTitle('Organisation Address Change')
				setErrorMessage('Failed to update address - Please Try Again')
			})
		setEditAddress(false)
	}

	const resetErrorMessage = () => {
		setErrorMessage('')
		setErrorTitle('')
	}

	const updateSection = section => {
		getOrganisation()
		setActiveSection(section)
	}

	const updateOverviewFilter = filter => {
		setFilter(filter)
		setActiveSection(OrganisationConstants.REPORTS_SECTION)
	}
	const handleFinviseDashboardClick = () =>
		setActiveSection(OrganisationConstants.FINVISE_DASHBOARD_SECTION)
	const handleFinvisePropertiesClick = () =>
		setActiveSection(OrganisationConstants.FINVISE_PROPERTIES_SECTION)
	const handleFinviseFeeRulesClick = () =>
		setActiveSection(OrganisationConstants.FINVISE_FEE_RULES_SECTION)
	const handleNameClick = () => {
		setActiveSection(OrganisationConstants.SUMMARY_SECTION)
	}

	const handlePeopleClick = () => {
		setActiveSection(OrganisationConstants.PEOPLE_SECTION)
	}

	const handleReportsClick = () => {
		setActiveSection(OrganisationConstants.REPORTS_SECTION)
	}

	const handleValuationReportsClick = () => {
		setActiveSection(OrganisationConstants.REPORT_VALUATION_SECTION)
	}

	const handleRICSReportsClick = () => {
		setActiveSection(OrganisationConstants.REPORT_RICS_SECTION)
	}

	const handleInsightsReportsClick = () => {
		setActiveSection(OrganisationConstants.REPORT_INSIGHT_SECTION)
	}

	const handleAllReportsClick = () => {
		setActiveSection(OrganisationConstants.REPORT_ALL_SECTION)
	}

	const handleOrgClick = () => {
		window.location.assign('/admin/organisations')
	}

	const updateProfile = profile => {
		setProfile(profile)
	}

	const updateNotifications = bool => {
		setNotifications(bool)
		let body = { notifications: bool }
		let response = null
		if (profile.role_id === roles.ROLE_ADMIN) {
			// Pass the id through to the api call for full admin
			response = org_api.putOrgNotifications(org_id, body)
		}
		if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
			// Let the api determine the org id based on the org admin logged in
			response = org_admin_api.putOrgNotifications(body)
		}
		response
			.then(() => {})
			.catch(err => {
				console.log(err)
			})
	}

	useEffect(() => {
    if (!profile) {
      getProfile()
    }
	}, [])

	useEffect(() => {
		getOrganisation()
	}, [profile])

	useEffect(() => {
		getOrganisation()
	}, [profile, org_id])

	useEffect(() => {
		if (!organisation) return
		setNotifications(organisation.notifications)
	}, [organisation])

	const updateAddressValue = value => {
		if (!value) {
			setOrgAddress('')
		} else {
			if (value.length <= 300) {
				setOrgAddress(value)
			}
		}
	}

	const handleDragOver = ev => {
		ev.preventDefault()
	}

	const handlePdfUpload = file => {
		if (!file) return
		let _body = { file: file[0] }
		let response = org_api.postOrgRicsTerms(org_id, _body)
		response
			.then(response => {
				if (
					response.data.response ===
					'Organisations rics terms successfully updated'
				) {
					setErrorTitle('Organisation Rics Terms Change')
					setErrorMessage('Successfully updated Rics Terms')
				} else {
					setErrorTitle('Organisation Rics Terms Change')
					setErrorMessage('Failed to update Rics Terms - Please Try Again')
				}
			})
			.catch(err => {
				setErrorTitle('Organisation Rics Terms Change')
				setErrorMessage('Failed to update Rics Terms - Please Try Again')
			})
	}

	const handleDrop = async ev => {
		ev.preventDefault()
		let _files = ev.dataTransfer.files
		let _temp_files = []
		_temp_files = []
		if (validFileSize(_temp_files, _files[0].size)) {
			if (_files[0].type === 'application/pdf') {
				let base64_link = await ImageUtils.convertBase64(_files[0])
				let _file = {
					name: _files[0].name,
					base64: base64_link.split(',')[1],
					size: _files[0].size,
				}
				_temp_files.push(_file)
			}
		}
		if (_temp_files) {
			setFiles(_temp_files)
			handlePdfUpload(_temp_files)
		}
	}

	const handleSelect = async ev => {
		let _temp_files = []
		if (validFileSize(_temp_files, ev.target.files[0].size)) {
			if (ev.target.files[0].type === 'application/pdf') {
				let base64 = await ImageUtils.convertBase64(ev.target.files[0])
				let _file = {
					name: ev.target.files[0].name,
					base64: base64.split(',')[1],
					size: ev.target.files[0].size,
				}
				_temp_files.push(_file)
			}
		}
		if (_temp_files) {
			setFiles(_temp_files)
			handlePdfUpload(_temp_files)
		}
	}

	const validFileSize = (_files, _upload_size) => {
		if (!_files || !_upload_size) return false
		if (_upload_size > 300000000) return false
		let _existing_size = 0
		for (let i = 0; i < _files.length; i++) {
			_existing_size = _existing_size + _files[i].size
		}
		let _total_size = _existing_size + _upload_size
		return _total_size <= 1000000000
	}

	const handleFileUploaderClick = () => {
		let element = document.getElementById('file-uploader')
		if (!element) return
		element.click()
	}

	const handleDelete = ev => {
		// HOOK UP DELETE FILE
		if (!ev) return
		let _files = [...files]
		_files.splice(ev.target.id, 1)
		setFiles(_files)
		let response = org_api.putOrgRicsTerms(org_id)
		response
			.then(response => {
				setErrorTitle('Organisation Rics Terms Change')
				setErrorMessage('Successfully updated Rics Terms')
			})
			.catch(err => {
				setErrorTitle('Organisation Rics Terms Change')
				setErrorMessage('Failed to update Rics Terms - Please Try Again')
			})
	}

	// Org admins only see Dashboard/Report Register when their organisation
	// has the "dashboard" feature or is on the allowed list. Everyone else
	// (admin included) keeps seeing them unconditionally, as before.
	const showFinviseDashboard =
		!(profile && profile.role_id === roles.ROLE_ORGANISATION_ADMIN) ||
		hasDashboardAccess(organisation)

	return (
		<>
			<MainHeader updateProfile={updateProfile.bind(this)} />
			<div className='admin-organisation-page-container'>
				<div className='admin-organisation-container'>
					<div className='admin-organisation-sidemenu col'>
						{profile && profile.role_id === roles.ROLE_ADMIN ? (
							<>
								<div className='admin-organisation-menu-title'>FINVISE</div>
								<div className='admin-organisation-menu-subtitle'>
									Admin view
								</div>

								<div
									className='admin-organisation-category-title link'
									onClick={handleOrgClick}
								>
									Organisations
								</div>
							</>
						) : null}
						<div className='admin-organisation-category-content'>
							<div
								className={
									activeSection === OrganisationConstants.SUMMARY_SECTION
										? 'admin-organisation-category-name active link'
										: 'admin-organisation-category-name link'
								}
								onClick={handleNameClick}
							>
								{organisation && organisation.name}
							</div>
							{showFinviseDashboard ? (
								<>
									<div
										className={
											activeSection ===
											OrganisationConstants.FINVISE_DASHBOARD_SECTION
												? 'admin-organisation-category-subheading active link'
												: 'admin-organisation-category-subheading link'
										}
										onClick={handleFinviseDashboardClick}
									>
										Dashboard
										<span className='admin-organisation-nav-badge'>New</span>
									</div>
									<div
										className={
											activeSection ===
											OrganisationConstants.FINVISE_PROPERTIES_SECTION
												? 'admin-organisation-category-subheading active link'
												: 'admin-organisation-category-subheading link'
										}
										onClick={handleFinvisePropertiesClick}
									>
										Report Register
										<span className='admin-organisation-nav-badge'>New</span>
									</div>
								</>
							) : null}
							{profile && profile.role_id === roles.ROLE_ADMIN ? (
								<div
									className={
										activeSection === OrganisationConstants.FINVISE_FEE_RULES_SECTION
											? 'admin-organisation-category-subheading active link'
											: 'admin-organisation-category-subheading link'
									}
									onClick={handleFinviseFeeRulesClick}
								>
									Fees Schedule
									<span className='admin-organisation-nav-badge'>New</span>
								</div>
							) : null}
							<div
								className={
									activeSection === OrganisationConstants.REPORTS_SECTION
										? 'admin-organisation-category-subheading active link'
										: 'admin-organisation-category-subheading link'
								}
								onClick={handleReportsClick}
								style={{ display: 'none' }}
							>
								Overview
							</div>
							<div
								className={
									activeSection ===
										OrganisationConstants.REPORT_VALUATION_SECTION ||
									activeSection === OrganisationConstants.REPORT_RICS_SECTION ||
									activeSection ===
										OrganisationConstants.REPORT_INSIGHT_SECTION ||
									activeSection === OrganisationConstants.REPORT_ALL_SECTION
										? 'admin-organisation-category-subheading active link'
										: 'admin-organisation-category-subheading link'
								}
								onClick={handleRICSReportsClick}
							>
								Reports
							</div>
							<div
								className={
									activeSection ===
									OrganisationConstants.REPORT_VALUATION_SECTION
										? 'admin-organisation-category-sub-subheading active link'
										: 'admin-organisation-category-sub-subheading link'
								}
								onClick={handleValuationReportsClick}
							>
								Finvise valuations
							</div>
							<div
								className={
									activeSection === OrganisationConstants.REPORT_RICS_SECTION
										? 'admin-organisation-category-sub-subheading active link'
										: 'admin-organisation-category-sub-subheading link'
								}
								onClick={handleRICSReportsClick}
							>
								RICS reports
							</div>
							<div
								className={
									activeSection === OrganisationConstants.REPORT_INSIGHT_SECTION
										? 'admin-organisation-category-sub-subheading active link'
										: 'admin-organisation-category-sub-subheading link'
								}
								onClick={handleInsightsReportsClick}
							>
								Market insights
							</div>
							<div
								className={
									activeSection === OrganisationConstants.REPORT_ALL_SECTION
										? 'admin-organisation-category-sub-subheading active link'
										: 'admin-organisation-category-sub-subheading link'
								}
								onClick={handleAllReportsClick}
							>
								All reports
							</div>
							<div
								className={
									activeSection === OrganisationConstants.PEOPLE_SECTION
										? 'admin-organisation-category-subheading active link'
										: 'admin-organisation-category-subheading link'
								}
								onClick={handlePeopleClick}
							>
								Teams
							</div>
						</div>
					</div>
					<div className='admin-organisation-content col'>
						{activeSection === OrganisationConstants.SUMMARY_SECTION ? (
							<>
								<div className='admin-orgs-content-title'>
									{organisation && organisation.name}
								</div>
								<div className='summary-grids'>
									<div className='admin-orgs-summary-column large'>
										<OrganisationReportSummary
											organisation={organisation}
											updateSection={updateSection.bind(this)}
										/>
										{profile && profile.role_id === roles.ROLE_ADMIN ? (
											<div className='admin-orgs-summary-container'>
												<div className='summary-grid-notification-card'>
													<div className='summary-grids-notification-card-header'>
														Notifications
													</div>
													<div className='summary-grids-notification-card-body'>
														Notify users when a report is requested
													</div>
													<Slider
														update={updateNotifications.bind(this)}
														state={notifications}
													/>
												</div>
											</div>
										) : null}
									</div>
									<div className='admin-orgs-summary-column large'>
										<div className='admin-orgs-summary-container'>
											<OrganisationTeamSummary
												organisation={organisation}
												updateSection={updateSection.bind(this)}
											/>
											{profile &&
											organisation &&
											(profile.role_id === 2 || profile.role_id === 3) &&
											organisation.billing_method === 1 ? (
												<CreditBasedBillingCard
													organisation={organisation}
													role_id={profile.role_id}
													updateSection={updateSection.bind(this)}
												/>
											) : null}
											{profile &&
											organisation &&
											profile.role_id === 3 &&
											organisation.billing_method === 2 ? (
												<UsageBasedBillingCard
													organisation={organisation}
													updateSection={updateSection.bind(this)}
												/>
											) : null}
											{profile &&
											organisation &&
											profile.role_id === roles.ROLE_ADMIN ? (
												<CommercialValuationRequestsToggle org_id={org_id} />
											) : null}
										</div>
										<div className='admin-orgs-summary-container'>
											{profile && organisation && profile.role_id === 3 ? (
												<div className='admin-orgs-address-container'>
													<div className='admin-orgs-address-title-row'>
														Address
														<img
															src={edit}
															onClick={() => setEditAddress(!editAddress)}
														/>
													</div>
													<div
														className={
															editAddress
																? 'admin-orgs-address-input-container'
																: 'admin-orgs-address-input-container disabled'
														}
													>
														<textarea
															value={orgAddress}
															onChange={ev =>
																updateAddressValue(ev.target.value)
															}
														/>
													</div>
													<div className='admin-orgs-address-buttons-container'>
														{editAddress ? (
															<>
																<div
																	className='admin-orgs-address-button'
																	onClick={() => setEditAddress(false)}
																>
																	Cancel
																</div>
																<div
																	className='admin-orgs-address-button'
																	onClick={() => submitOrgAddress()}
																>
																	Save
																</div>
															</>
														) : null}
													</div>
												</div>
											) : null}
										</div>
										<div className='admin-orgs-summary-container'>
											{profile && organisation && profile.role_id === 3 ? (
												<div className='admin-orgs-address-container'>
													<div className='admin-orgs-address-title-row'>
														CLIENT RICS TERMS
													</div>
													<div className='admin-orgs-address-description'>
														The PDF pages uploaded here will append every RICS
														report created for this client.
													</div>
													<div className='admin-orgs-upload-container'>
														<div
															className='multi-file-upload-container org'
															onDragOver={handleDragOver}
															onDrop={handleDrop}
														>
															<img src={cloud} alt='upload cloud' />
															<div>
																Drag and drop files here or &nbsp;
																<u
																	style={{ cursor: 'pointer' }}
																	onClick={handleFileUploaderClick}
																>
																	select a file
																</u>
															</div>
															<input
																type='file'
																id='file-uploader'
																multiple={true}
																className='file-uploader-hidden'
																onChange={handleSelect}
															/>
														</div>
													</div>
													{files !== [] ? (
														<div
															className='multi-file-uploaded-container'
															id='scrollbar1'
														>
															{files &&
																files.map((file, idx) => {
																	return (
																		<>
																			<div
																				className='multi-file-cell-container'
																				key={idx}
																			>
																				<div className='multi-file-cell-text'>
																					{file.name}
																				</div>
																				<div
																					className='multi-file-cell-delete-container link'
																					id={idx}
																					onClick={ev => handleDelete(ev)}
																				>
																					<img src={cancel} alt='X' id={idx} />
																				</div>
																			</div>
																		</>
																	)
																})}
														</div>
													) : null}
												</div>
											) : null}
										</div>
										<div className='admin-orgs-summary-container'>
						          {profile &&
						          organisation &&
						          profile.role_id === roles.ROLE_ADMIN ? (
						          	<ReportLengthChooseAllowToggle org_id={org_id} reportLengthAllow={organisation.allow_report_length_select} />
						          ) : null}
							        {profile &&
							        organisation &&
							        profile.role_id === roles.ROLE_ADMIN ? (
							        	<DefaultReportLengthSelect org_id={org_id} defaultReportLengthId={organisation.settings && organisation.settings.default_report_length_id} />
							        ) : null}
									  </div>
									</div>
								</div>
							</>
						) : null}
						{activeSection === OrganisationConstants.REPORTS_SECTION ? (
							<>
								<AdminReportOverviewGrid
									profile={profile}
									organisation={organisation}
									filter={filter}
								/>
							</>
						) : null}
						{activeSection ===
						OrganisationConstants.REPORT_VALUATION_SECTION ? (
							<>
								<ManagementReports
									report_type={1}
									heading='Valuation reports'
									orgId={org_id}
									updateFilter={updateOverviewFilter.bind(this)}
								/>
							</>
						) : null}
						{activeSection === OrganisationConstants.REPORT_RICS_SECTION ? (
							<>
								<ManagementReports
									report_type={2}
									heading='RICS reports'
									orgId={org_id}
									updateFilter={updateOverviewFilter.bind(this)}
								/>
							</>
						) : null}
						{showFinviseDashboard &&
						activeSection === OrganisationConstants.FINVISE_DASHBOARD_SECTION ? (
							<FinviseDashboard
								orgId={org_id}
								clientName={organisation?.name}
								range={finviseRange}
								onRangeChange={setFinviseRange}
								orgFilter={finviseOrgFilter}
								onOrgFilterChange={setFinviseOrgFilter}
							/>
						) : null}
						{showFinviseDashboard &&
						activeSection === OrganisationConstants.FINVISE_PROPERTIES_SECTION ? (
							<FinviseProperties
								orgId={org_id}
								range={finviseRange}
								onRangeChange={setFinviseRange}
								orgFilter={finviseOrgFilter}
								onOrgFilterChange={setFinviseOrgFilter}
							/>
						) : null}
						{activeSection ===
						OrganisationConstants.FINVISE_FEE_RULES_SECTION ? (
							<FinviseFeeRules orgId={org_id} />
						) : null}
						{activeSection === OrganisationConstants.REPORT_INSIGHT_SECTION ? (
							<>
								<ManagementReports
									report_type={3}
									heading='Market insight reports'
									orgId={org_id}
									updateFilter={updateOverviewFilter.bind(this)}
								/>
							</>
						) : null}
						{activeSection === OrganisationConstants.REPORT_ALL_SECTION ? (
							<>
								<ManagementReports
									report_type={0}
									heading='All reports'
									orgId={org_id}
									updateFilter={updateOverviewFilter.bind(this)}
								/>
							</>
						) : null}
						{activeSection === OrganisationConstants.PEOPLE_SECTION ? (
							<>
								<OrganisationPeople
									organisation={organisation}
									profile={profile}
								/>
							</>
						) : null}
						{activeSection === OrganisationConstants.CREDIT_SECTION ? (
							<>
								<OrganisationCreditDetails
									organisation={organisation}
									updateSection={updateSection.bind(this)}
								/>
							</>
						) : null}
					</div>
				</div>
			</div>
			{errorMessage && errorTitle ? (
				<GenericDialog
					title={errorTitle}
					text={errorMessage}
					buttons={okButton}
					result={() => resetErrorMessage()}
				/>
			) : null}
		</>
	)
}

export default AdminOrganisation
